import * as React from 'react';
import { PromptConfirmationProps } from './types';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';

import styles from './prompt-confirmation.scss';

const promptConfirmationComponent = (props: PromptConfirmationProps) => {

  const renderMessage = (key: number, label: string, text: string) => {
    
    return (
      <li key={key} className={styles[props.confirmationStyle]}>
        <span className={ `${styles[props.confirmationStyle]} ${styles.label}`}>{label}</span>
        <span className={ `${styles[props.confirmationStyle]} ${styles.message}`}>{text} </span>
      </li>
    );      
  };  

  const messageList = props.confirmMessages && props.confirmMessages.map(e=>renderMessage(e.key, e.label, e.message));

  return (
    <ModalWrapper
      headerTitle={props.title}
      btnCancelTitle={props.cancelText}
      btnTitle={props.continueText}
      onClose={props.onCancel}
      onDone={props.onContinue}
      closeOnDone={props.closeOnDone}
      btnExtraFooterActionOverride={props.btnExtraFooterActionOverride}>
      <p className={styles.text}>{props.description}</p>
      <p>{messageList}</p>
    </ModalWrapper>
  );
};

export { promptConfirmationComponent as PromptConfirmation };
